var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"headerClearBtn",on:{"click":_vm.clear}},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ruby',[_vm._v("全消去"),_c('rt',[_vm._v("ぜんしょうきょ")])])}]

export { render, staticRenderFns }